//- SCRIPTS DO ESPECIAL

$(function () {
    var $general = $('#general-special');

    var featured = function() {
        var scrollTop = $(window).scrollTop(),
            valueBg = 0,
            lastScrollTop = 0;

        $(document).scroll(function() {
            scrollTop = $(window).scrollTop();
            valueBg = -parseInt(scrollTop / 10);

            if (scrollTop >= $('.featured', $general).offset().top && scrollTop <= $('.featured', $general).offset().top + $('.featured', $general).outerHeight()) {
                $('.featured', $general).css('background-position', 'center ' + valueBg + 'px');
                lastScrollTop = scrollTop;
            }
        })
    }

    var carousel = function() {
        $('.carousel', $general).each(function() {
            var $carousel = $(this),
                $wrapper = $('.wrapper', $carousel),
                options = {
                    items: 1,
                    loop: true,
                    navContainer: $wrapper,
                    nav: true,
                    dotsContainer: $('.pagination', $carousel)
                };

            $wrapper.owlCarousel(options);
        })
    }

    var map = function() {
        var $blockMap = $('.block-map', $general),
            scrollTop = $(window).scrollTop(),
            topDistance = $blockMap.offset().top,
            windowHeight = $(window).height(),
            windowWidth = $(window).width(),
            gridTop = windowHeight * .1,
            gridBottom = windowHeight * .9;

        function getMeters(value, height) {
            var meters = 12000, 
                result = (value * 100) / height,
                resultMeters = parseInt((meters * result) / 100);

            if (resultMeters > 11950) {
                $('.meters span', $general).text(meters);
            } else {
                $('.meters span', $general).text(resultMeters);
            }

            $('.meters', $general).addClass('active');
        }

        $(document).scroll(function() {
            topDistance = $blockMap.offset().top;
            scrollTop = $(window).scrollTop();

            if (scrollTop - topDistance >= $blockMap.outerHeight() * 0.03 && scrollTop <= topDistance + 100 + ($blockMap.outerHeight() - $blockMap.outerHeight() * 0.19)) {
                var value = scrollTop - topDistance - $blockMap.outerHeight() * 0.03,
                    height = $blockMap.outerHeight() - (($blockMap.outerHeight() * 0.03) + ($blockMap.outerHeight() * 0.19));

                getMeters(value, height);
            } else {
                $('.meters', $general).removeClass('active');
            }

            $('.info', $blockMap).each(function(index, item) {
                var $this = $(this),
                    thisTop = $this.offset().top - scrollTop,
                    bounding = $this.get(0).getBoundingClientRect();

                if (windowWidth >= 1024) {
                    if (thisTop >= gridTop && (thisTop + $this.height()) <= gridBottom) {
                        $this.addClass('active');
                    }

                    if (bounding.top <= 0 - $this.outerHeight() || bounding.bottom >= (window.innerHeight + $this.outerHeight() || document.documentElement.clientHeight + $this.outerHeight())) {
                        $this.removeClass('active');
                    }
                } else {
                    gridTop = windowHeight * .1,
                    gridBottom = windowHeight * .5;

                    if (thisTop >= gridTop && (thisTop + $this.height()) <= gridBottom) {
                        $this.addClass('active');
                    }

                    if (bounding.top <= 0 - $this.outerHeight() || bounding.bottom >= (window.innerHeight + $this.outerHeight() || document.documentElement.clientHeight + $this.outerHeight())) {
                        $this.removeClass('active');
                    }
                }
            });
        })
    }

    if ($('body').hasClass('mobile')) {
    } else {
        $('.custom-scroll').scrollbar({
            autoScrollSize: false,
            duration: 100,
            ignoreMobile: true
        });
    }

    if ($('.custom-video', $general).length) {
        var player = new Plyr('.custom-video', {
            controls: ['play', 'progress', 'fullscreen', 'current-time'],
            fullscreen: { enabled: true, fallback: true, iosNative: true }
        });
    }

    // INIT
    featured();
    carousel();
    map();
});
